import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator, httpsCallable } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

/**
 * İstemci yapılandırması gizli değildir (Firebase tasarımı gereği herkese açıktır).
 * Gerçek koruma Security Rules + App Check + Cloud Function guard'larındadır.
 */
const app = initializeApp({
  apiKey: import.meta.env.VITE_FB_API_KEY,
  authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FB_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FB_MSG_SENDER_ID,
  appId: import.meta.env.VITE_FB_APP_ID,
});

export const REGION = "europe-west1";

export const auth = getAuth(app);
export const db = getFirestore(app);
export const fns = getFunctions(app, REGION);
export const storage = getStorage(app);

const useEmulator = import.meta.env.VITE_USE_EMULATOR === "1";

if (useEmulator) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectFunctionsEmulator(fns, "127.0.0.1", 5001);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
} else if (import.meta.env.VITE_RECAPTCHA_KEY) {
  // App Check iki aşamalı devreye alınır: önce izleme, "unverified request" oranı
  // %0'a inince Rules tarafında APPCHECK_ENFORCED() true yapılır.
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(import.meta.env.VITE_RECAPTCHA_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

/** Tipli callable yardımcısı. Hata mesajları Cloud Function'dan Türkçe gelir. */
export function callable<TIn, TOut>(name: string) {
  const fn = httpsCallable<TIn, TOut>(fns, name);
  return async (data: TIn): Promise<TOut> => (await fn(data)).data;
}
